<button *ngIf="!showTriggerDataForm && editable" class="btn btn-info" [disabled]="deviceParamLirisV3TriggerDataArray.length > 5 && sensorType === 18" (click)="setEditable()">Add
    #{{deviceParamLirisV3TriggerDataArray.length}}
</button>
<div *ngIf="showTriggerDataForm && editable" class="edit-container-params">
    <h4>{{currentTriggerDataIndexForEdition !== null ? ('EDIT'|translate) : ('ADD'|translate) }} {{modeName.toLowerCase()}}
        #{{currentTriggerDataIndexForEdition
        !== null ? currentTriggerDataIndexForEdition : deviceParamLirisV3TriggerDataArray.length }}
    </h4>
    <form [formGroup]="triggerDataForm">
        <mat-form-field>
            <mat-select placeholder="{{'CHANNEL'|translate}}" formControlName="channel" [disabled]="axeInclino !==2">
                <mat-option [value]="0">{{'CHANNEL'|translate}} 1</mat-option>
                <mat-option [value]="1">{{'CHANNEL'|translate}} 2</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <input matInput [placeholder]="modeName === 'Amplitude' ? 'Temps (ms)' : 'Threshold (µm)'"
                   formControlName="timeOrThreshold" required type="number">
        </mat-form-field>
        <mat-form-field>
            <input matInput [placeholder]="modeName === 'Amplitude' ? 'Amplitude (µm)' : 'Hysteresis (µm)'"
                   formControlName="amplOrHyst" required type="number">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Pretrig (ms)" formControlName="preTrigger" required type="number">
        </mat-form-field>

        <mat-form-field>
            <input matInput placeholder="Posttrig (ms)" formControlName="postTrigger" required type="number">
        </mat-form-field>
        <mat-form-field>
            <mat-select placeholder="{{'EFFECT'|translate}}" formControlName="effect">
                <mat-option [value]="0">No effect</mat-option>
                <mat-option [value]="1">QD file</mat-option>
                <mat-option [value]="2">Dynamic File</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-slide-toggle formControlName="activated">
            {{triggerDataForm.value.activated ? ('ACTIVE' | translate) :
            ('INACTIVE' | translate)}}
        </mat-slide-toggle>


        <button class="btn btn-danger btn-float-right" (click)="cancelTriggerData()">
            Cancel
        </button>
        <button class="btn btn-success btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== null"
                (click)="editTriggerData()">{{'EDIT'|translate}}
            #{{currentTriggerDataIndexForEdition}}
        </button>
        <button class="btn btn-info btn-float-right" *ngIf="currentTriggerDataIndexForEdition === null"
                (click)="addTriggerData()">{{'ADD'|translate}}

        </button>
    </form>


</div>
<div *ngFor="let triggerData of deviceParamLirisV3TriggerDataArray;let i = index">
    <div *ngIf="currentTriggerDataIndexForEdition === null" class="read-container-params">
        <h4> {{modeName}}#{{i}}</h4>
        <form>
            <mat-form-field>
                <mat-select placeholder="{{'CHANNEL'|translate}}"
                            [value]="deviceParamLirisV3TriggerDataArray[i].channel"
                            [disabled]="true">
                    <mat-option [value]="0">{{'CHANNEL'|translate}} 1</mat-option>
                    <mat-option [value]="1">{{'CHANNEL'|translate}} 2</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <input matInput [placeholder]="modeName === 'Amplitude' ? 'Temps (ms)' : 'Threshold (µm)'"
                       [value]="deviceParamLirisV3TriggerDataArray[i].timeOrThreshold"
                       [readonly]="true"
                       type="number">
            </mat-form-field>
            <mat-form-field>
                <input matInput [placeholder]="modeName === 'Amplitude' ? 'Amplitude (µm)' : 'Hysteresis (µm)'"
                       [value]="deviceParamLirisV3TriggerDataArray[i].amplOrHyst"
                       [readonly]="true"
                       type="number">
            </mat-form-field>

            <mat-form-field>
                <input matInput placeholder="Pretrig (ms)" [value]="deviceParamLirisV3TriggerDataArray[i].preTrigger"
                       [readonly]="true"
                       type="number">
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="Posttrig (ms)" [value]="deviceParamLirisV3TriggerDataArray[i].postTrigger"
                       [readonly]="true"
                       type="number">
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'EFFECT'|translate}}" [value]="deviceParamLirisV3TriggerDataArray[i].effect"
                            [disabled]="true">
                    <mat-option [value]="0">No effect</mat-option>
                    <mat-option [value]="1">QD file</mat-option>
                    <mat-option [value]="2">Dynamic File</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-slide-toggle [(ngModel)]="deviceParamLirisV3TriggerDataArray[i].activated"
                              [ngModelOptions]="{standalone: true}"
                              [disabled]="true">
                {{deviceParamLirisV3TriggerDataArray[i].activated ? ('ACTIVE' | translate) :
                ('INACTIVE' | translate)}}
            </mat-slide-toggle>
            <button class="btn btn-danger btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== i && editable"
                    (click)="removeTriggerData(i)">
                {{'DELETE'|translate}}
            </button>
            <button class="btn btn-success btn-float-right" *ngIf="currentTriggerDataIndexForEdition !== i && editable"
                    (click)="setFormWithTriggerData(i)">{{'EDIT'|translate}}
                #{{i}}
            </button>

        </form>

    </div>
</div>
